// HOMOLOGAÇÃO
export const API_BASE_URL =
  // process.env.REACT_APP_API_URL ||
  // "https://homolo-api-core-comunicacao-git-631554619185.southamerica-east1.run.app/api";

// PRODUÇÃO
// export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://api-core-comunicacao-git-631554619185.europe-west1.run.app/api";

// LOCAL
// export const API_BASE_URL =
//   process.env.REACT_APP_API_URL || "http://localhost:5000/api";
